import createClient, { type Middleware } from 'openapi-fetch';
import type { paths, operations } from './openapi';
import { User } from 'firebase/auth';

const client = createClient<paths>({ baseUrl: import.meta.env.VITE_CLOUDFLARE_BASE_URL });

let currentUser: User|null = null;

// this needs to be subscribed to the Firestore auth service
export function apiAuthStateChanged(user : User|null) {
  currentUser = user;
}

const AddAuthorizationHeader: Middleware = {
    async onRequest({ request }) {
      const token = await currentUser?.getIdToken();
      request.headers.set('Authorization', `Bearer ${token}`);
      return request;
    }
}

client.use(AddAuthorizationHeader)

export const tfpapi = {

  system: {
    whitelist: {

      get: (queryParams?: operations['get_BlackWhitelistList']['parameters']['query']) => {
        return client.GET('/api/v1/system/whitelist', { params: { query: queryParams } });
      },
      // only ever accessible for admins anyway
      // add: (requestBody: NonNullable<operations['post_BlackWhitelistCreate']['requestBody']>['content']['application/json']) => {
      //   return client.POST('/api/v1/system/whitelist', { body: requestBody });
      // },
      // deleteOne: (pathParams: operations['delete_BlackWhitelistDelete']['parameters']['path']) => {
      //   return client.DELETE('/api/v1/system/whitelist/{email}', { params: { path: pathParams } });
      // },

    },

    dtls: {

      get: (queryParams?: operations['get_UserDtlsList']['parameters']['query']) => {
        return client.GET('/api/v1/system/user-dtls', { params: { query: queryParams } });
      },
      getOne: (pathParams: operations['get_UserDtlsRead']['parameters']['path']) => {
        return client.GET('/api/v1/system/user-dtls/{providerUserUUID}', { params: { path: pathParams } });
      },
      put: (pathParams: operations['put_UserDtlsUpdate']['parameters']['path'], requestBody: NonNullable<operations['put_UserDtlsUpdate']['requestBody']>['content']['application/json']) => {
        return client.PUT('/api/v1/system/user-dtls/{providerUserUUID}', { params: { path: pathParams} , body: requestBody });
      },
      // only ever accessible for admins anyway
      // delete: (pathParams: operations['delete_UserDtlsDelete']['parameters']['path']) => {
      //   return client.DELETE('/api/v1/system/user-dtls/{providerUserUUID}', { params: { path: pathParams } });
      // },
    },

    signin: (requestBody: NonNullable<operations['post_SignInEndpoint']['requestBody']>['content']['application/json']) => {
      return client.POST('/api/v1/system/signin', { body: requestBody })
    },

    acceptance: {
      update: (requestBody: NonNullable<operations['post_AcceptanceEndpoint']['requestBody']>['content']['application/json']) => {
        return client.POST('/api/v1/system/acceptance', { body: requestBody });
      }
    },

    subscribe: {
      update: (requestBody: NonNullable<operations['post_SubscribeEndpoint']['requestBody']>['content']['application/json']) => {
        return client.POST('/api/v1/system/subscribe', { body: requestBody });
      }
    },



  },

  user: {

    settings: {

      get: (pathParams: operations['get_UserSettingsList']['parameters']['path'], queryParams?: operations['get_UserSettingsList']['parameters']['query']) => {
        return client.GET('/api/v1/user/{userUUID}/settings', { params: { path: pathParams, query: queryParams } });
      },
      set: (pathParams: operations['post_UserSettingsUpsert']['parameters']['path'], requestBody: NonNullable<operations['post_UserSettingsUpsert']['requestBody']>['content']['application/json']) => {
        return client.POST('/api/v1/user/{userUUID}/settings', { params: { path: pathParams }, body: requestBody });
      },

    },

    trainers: {
      get: (pathParams: operations['get_TrainersList']['parameters']['path'], queryParams?: operations['get_TrainersList']['parameters']['query']) => {
        return client.GET('/api/v1/user/{userUUID}/trainers', { params: { path: pathParams, query: queryParams } });
      },
      add: (pathParams: operations['get_TrainersList']['parameters']['path'], requestBody: NonNullable<operations['get_TrainersList']['requestBody']>['content']['application/json']) => {
        return client.POST('/api/v1/user/{userUUID}/trainers', { params: { path: pathParams }, body: requestBody });
      },
      deleteOne: (pathParams: operations['delete_TrainersDelete']['parameters']['path'], requestBody: NonNullable<operations['delete_TrainersDelete']['requestBody']>['content']['application/json']) => {
        return client.DELETE('/api/v1/user/{userUUID}/trainers/{trainerUUID}', { params: { path: pathParams }, body: requestBody });
      },

      workouts: {
        get: (pathParams: operations['get_TrainerWorkoutsList']['parameters']['path'], queryParams?: operations['get_TrainerWorkoutsList']['parameters']['query']) => {
          return client.GET('/api/v1/user/{userUUID}/trainers/workouts', { params: { path: pathParams, query: queryParams }});
        },
      }

    },

    comms: (pathParams: operations['get_UserCommsRead']['parameters']['path'], queryParams?: operations['get_UserCommsRead']['parameters']['query']) => {
      return client.GET('/api/v1/user/{userUUID}/comms', { params: { path: pathParams, query: queryParams }});
    },

    workouts: {
      logs: {
        get: (pathParams: operations['get_TrainerWorkoutsList']['parameters']['path'], queryParams?: operations['get_TrainerWorkoutsList']['parameters']['query']) => {
          return client.GET('/api/v1/user/{userUUID}/workouts/logs', { params: { path: pathParams, query: queryParams }});
        },
      }
    },

    chat: {

      get: (pathParams: operations['get_UserChatList']['parameters']['path'], queryParams?: operations['get_UserChatList']['parameters']['query']) => {
        return client.GET('/api/v1/user/{userUUID}/chat', { params: { path: pathParams, query: queryParams } });
      },
      set: (pathParams: operations['post_UserChatUpsert']['parameters']['path'], requestBody: NonNullable<operations['post_UserChatUpsert']['requestBody']>['content']['application/json']) => {
        return client.POST('/api/v1/user/{userUUID}/chat', { params: { path: pathParams }, body: requestBody });
      },

    },

  },

  trainer: {
    clients: {
      get: (pathParams: operations['get_ClientsList']['parameters']['path'], queryParams?: operations['get_ClientsList']['parameters']['query']) => {
        return client.GET('/api/v1/trainer/{trainerUUID}/clients', { params: { path: pathParams, query: queryParams } });
      },
      add: (pathParams: operations['post_ClientsInsert']['parameters']['path'], requestBody: NonNullable<operations['post_ClientsInsert']['requestBody']>['content']['application/json']) => {
        return client.POST('/api/v1/trainer/{trainerUUID}/clients', { params: { path: pathParams }, body: requestBody});
      },
      deleteOne: (pathParams: operations['delete_ClientsDelete']['parameters']['path'], requestBody: NonNullable<operations['delete_ClientsDelete']['requestBody']>['content']['application/json']) => {
        return client.DELETE('/api/v1/trainer/{trainerUUID}/clients/{userUUID}', { params: { path: pathParams }, body: requestBody });
      },

    },

    comms: {
      get: (pathParams: operations['get_TrainerCommsRead']['parameters']['path'], queryParams?: operations['get_TrainerCommsRead']['parameters']['query']) => {
        return client.GET('/api/v1/trainer/{trainerUUID}/comms', { params: { path: pathParams, query: queryParams }});
      },
      getUnresolvedActions: (
        pathParams: operations['get_TrainerCommsUnresolvedList']['parameters']['path'],
        queryParams?: operations['get_TrainerCommsUnresolvedList']['parameters']['query']
      ) => {
        return client.GET('/api/v1/trainer/{trainerUUID}/comms/unresolved', {
          params: { path: pathParams, query: queryParams },
        });
      },
      getActionStats: (
        pathParams: operations['get_TrainerCommsResolveStatsList']['parameters']['path'],
        queryParams?: operations['get_TrainerCommsResolveStatsList']['parameters']['query']
      ) => {
        return client.GET('/api/v1/trainer/{trainerUUID}/comms/resolve-stats', {
          params: { path: pathParams, query: queryParams },
        });
      },
    },


    configuration: {

      get: (pathParams: operations['get_ConfigurationList']['parameters']['path'], queryParams?: operations['get_ConfigurationList']['parameters']['query']) => {
        return client.GET('/api/v1/trainer/{trainerUUID}/configuration', { params: { path: pathParams, query: queryParams } });
      },
      set: (pathParams: operations['put_ConfigurationUpsert']['parameters']['path'], requestBody: NonNullable<operations['put_ConfigurationUpsert']['requestBody']>['content']['application/json']) => {
        return client.PUT('/api/v1/trainer/{trainerUUID}/configuration/{id}', { params: { path: pathParams }, body: requestBody });
      },

    },

    subscriptionlog: (pathParams: operations['get_SubscriptionLogList']['parameters']['path'], queryParams?: operations['get_SubscriptionLogList']['parameters']['query']) => {
      return client.GET('/api/v1/trainer/{trainerUUID}/subscriptionlog', { params: { path: pathParams, query: queryParams } });
    },

    workouts: {
      get: (pathParams: operations['get_WorkoutsList']['parameters']['path'], queryParams?: operations['get_WorkoutsList']['parameters']['query']) => {
        return client.GET('/api/v1/trainer/{trainerUUID}/workouts', { params: { path: pathParams, query: queryParams } });
      },
      add: (pathParams: operations['post_WorkoutsCreate']['parameters']['path'], requestBody: NonNullable<operations['post_WorkoutsCreate']['requestBody']>['content']['application/json']) => {
        return client.POST('/api/v1/trainer/{trainerUUID}/workouts', { params: { path: pathParams }, body: requestBody });
      },
      set: (pathParams: operations['put_WorkoutsUpdate']['parameters']['path'], requestBody: NonNullable<operations['put_WorkoutsUpdate']['requestBody']>['content']['application/json']) => {
        return client.PUT('/api/v1/trainer/{trainerUUID}/workouts/{planUUID}', { params: { path: pathParams }, body: requestBody });
      },
      publish: (pathParams: operations['post_WorkoutsPublish']['parameters']['path']) => {
        return client.POST('/api/v1/trainer/{trainerUUID}/workouts/{planUUID}/publish', { params: { path: pathParams } });
      },

      logs: {
        get: (pathParams: operations['get_WorkoutsLogsList']['parameters']['path'], queryParams?: operations['get_WorkoutsLogsList']['parameters']['query']) => {
          return client.GET('/api/v1/trainer/{trainerUUID}/workouts/logs', { params: { path: pathParams, query: queryParams }});
        },
      },


      client: {
        get: (pathParams: operations['get_ClientWorkoutsList']['parameters']['path'], queryParams?: operations['get_ClientWorkoutsList']['parameters']['query']) => {
          return client.GET('/api/v1/trainer/{trainerUUID}/clients/workouts', { params: { path: pathParams, query: queryParams }});
        },
      }
    },

    media: {

      getAll: (
        pathParams: operations['get_MediaList']['parameters']['path'],
        queryParams?: operations['get_MediaList']['parameters']['query']
      ) => {
        return client.GET('/api/v1/trainer/{trainerUUID}/media', {
          params: { path: pathParams, query: queryParams },
        });
      },
      add: (
        pathParams: operations['post_MediaCreate']['parameters']['path'],
        requestBody: NonNullable<operations['post_MediaCreate']['requestBody']>['content']['application/json']
      ) => {
        return client.POST('/api/v1/trainer/{trainerUUID}/media', { // Path from openapi.d.ts
          params: { path: pathParams },
          body: requestBody,
        });
      },
      updateDescription: (
        pathParams: operations['patch_MediaDescUpdate']['parameters']['path'],
        requestBody: NonNullable<operations['patch_MediaDescUpdate']['requestBody']>['content']['application/json']
      ) => {
        return client.PATCH('/api/v1/trainer/{trainerUUID}/media/{mediaUUID}', {
          params: { path: pathParams },
          body: requestBody,
        });
      },
      delete: (pathParams: operations['delete_MediaDelete']['parameters']['path']) => {
        return client.DELETE('/api/v1/trainer/{trainerUUID}/media/{mediaUUID}', { params: { path: pathParams } });
      },

    },

    mediastructure: {
      getAll: (pathParams: operations['get_MediaStructList']['parameters']['path']) => {
        return client.GET('/api/v1/trainer/{trainerUUID}/media-structure', {
          params: { path: pathParams }
        });
      },
      add: (
        pathParams: operations['post_MediaStructCreate']['parameters']['path'],
        requestBody: NonNullable<operations['post_MediaStructCreate']['requestBody']>['content']['application/json']
      ) => {
        return client.POST('/api/v1/trainer/{trainerUUID}/media-structure', {
          params: { path: pathParams },
          body: requestBody,
        });
      },
      delete: (pathParams: operations['delete_MediaStructDelete']['parameters']['path']) => {
        return client.DELETE('/api/v1/trainer/{trainerUUID}/media-structure/{id}', {
          params: { path: pathParams }
        });
      }
    }


  },

  journal: {
    log: {
      get: (
        pathParams: operations['get_JournalList']['parameters']['path'],
        queryParams?: operations['get_JournalList']['parameters']['query']
      ) => {
        return client.GET('/api/v1/journal/{trainerUUID}/{userUUID}/log', {
          params: { path: pathParams, query: queryParams },
        });
      },
      getUnresolvedActions: (
        pathParams: operations['get_JournalUnresolvedList']['parameters']['path'],
        queryParams?: operations['get_JournalUnresolvedList']['parameters']['query']
      ) => {
        return client.GET('/api/v1/journal/{trainerUUID}/{userUUID}/log/unresolved', {
          params: { path: pathParams, query: queryParams },
        });
      },
      getActionStats: (
        pathParams: operations['get_JournalResolveStatsList']['parameters']['path'],
        queryParams?: operations['get_JournalResolveStatsList']['parameters']['query']
      ) => {
        return client.GET('/api/v1/journal/{trainerUUID}/{userUUID}/log/resolve-stats', {
          params: { path: pathParams, query: queryParams },
        });
      },
      add: (
        pathParams: operations['post_JournalCreate']['parameters']['path'],
        requestBody: NonNullable<operations['post_JournalCreate']['requestBody']>['content']['application/json']
      ) => {
        return client.POST('/api/v1/journal/{trainerUUID}/{userUUID}/log', {
          params: { path: pathParams },
          body: requestBody,
        });
      },
    },

    subscriptionlog: (pathParams: operations['get_SubscriptionLogList']['parameters']['path'], queryParams?: operations['get_SubscriptionLogList']['parameters']['query']) => {
      return client.GET('/api/v1/journal/{trainerUUID}/{userUUID}/subscriptionlog', { params: { path: pathParams, query: queryParams } });
    },

    acceptancelog: {
      get: (pathParams: operations['get_AcceptanceLogList']['parameters']['path'], queryParams: operations['get_AcceptanceLogList']['parameters']['query']) => {
        return client.GET('/api/v1/journal/{trainerUUID}/{userUUID}/acceptancelog', { params: { path: pathParams, query: queryParams }});
      }
    },

    workoutlog: {

      get: (
        pathParams: operations['get_WorkoutLogList']['parameters']['path'],
        queryParams?: operations['get_WorkoutLogList']['parameters']['query']
      ) => {
        return client.GET('/api/v1/journal/{trainerUUID}/{userUUID}/workoutlog', {
          params: { path: pathParams, query: queryParams },
        });
      },
      set: (
        pathParams: operations['post_WorkoutLogUpsert']['parameters']['path'],
        requestBody: NonNullable<operations['post_WorkoutLogUpsert']['requestBody']>['content']['application/json']
      ) => {
        return client.POST('/api/v1/journal/{trainerUUID}/{userUUID}/workoutlog', {
          params: { path: pathParams },
          body: requestBody,
        });
      },

    },

    workouts: {
      get: (pathParams: operations['get_WorkoutPlansList']['parameters']['path'], queryParams?: operations['get_WorkoutPlansList']['parameters']['query']) => {
        return client.GET('/api/v1/journal/{trainerUUID}/{userUUID}/plans', { params: { path: pathParams, query: queryParams } });
      },
    },

  },

  chat: {

    // Chat Members
    getMembers: (pathParams: operations['get_ChatMembersList']['parameters']['path'], queryParams?: operations['get_ChatMembersList']['parameters']['query']) => {
      return client.GET('/api/v1/chat/{chatId}/members', { params: { path: pathParams, query: queryParams } });
    },
    addMember: (pathParams: operations['post_ChatMembersCreate']['parameters']['path'], requestBody: NonNullable<operations['post_ChatMembersCreate']['requestBody']>['content']['application/json']) => {
      return client.POST('/api/v1/chat/{chatId}/members', { params: { path: pathParams }, body: requestBody });
    },

    // Chat Messages
    getMsgs: (pathParams: operations['get_ChatList']['parameters']['path'], queryParams?: operations['get_ChatList']['parameters']['query']) => {
      return client.GET('/api/v1/chat/{chatId}/messages', { params: { path: pathParams, query: queryParams } });
    },
    addMsg: (pathParams: operations['post_ChatCreate']['parameters']['path'], requestBody: NonNullable<operations['post_ChatCreate']['requestBody']>['content']['application/json']) => {
      return client.POST('/api/v1/chat/{chatId}/messages', { params: { path: pathParams }, body: requestBody });
    },

  },

  media: {

    // Media Upload/Download Endpoints
    getImageUploadUrl: (pathParams: operations['post_ImageUploadEndpoint']['parameters']['path'], requestBody: NonNullable<operations['post_ImageUploadEndpoint']['requestBody']>['content']['application/json']) => { // No parameters
      return client.POST('/api/v1/media/{userUUID}/image/upload', { params: { path: pathParams }, body: requestBody });
    },
    getImageDownloadUrl: (pathParams: operations['get_ImageDownloadEndpoint']['parameters']['path']) => {
      return client.GET('/api/v1/media/{userUUID}/image/d/{imageId}/{variant}', { params: { path: pathParams } });
    },
    getVideoUploadUrl: (pathParams: operations['post_VideoUploadEndpoint']['parameters']['path'], requestBody: NonNullable<operations['post_VideoUploadEndpoint']['requestBody']>['content']['application/json']) => {
      return client.POST('/api/v1/media/{userUUID}/video/upload', { params: { path: pathParams }, body: requestBody });
    },
    getVideoDownloadToken: (pathParams: operations['get_VideoDownloadEndpoint']['parameters']['path']) => {
      return client.GET('/api/v1/media/{userUUID}/video/d/{videoId}', { params: { path: pathParams } });
    },

  }


};

// Example of how to use a generated function:
/*
async function fetchUserDetails(providerId: string) {
  const { data, error } = await api.getUserDtlsDelete({ providerId });

  if (error) {
    console.error('Error deleting user details:', error);
    return;
  }

  if (data) {
    console.log('Successfully deleted user:', data.result);
  }
}

async function fetchWorkoutLogs(userId: string, planUuid: string, logDate: string | null) {
  // For the path with /date
  const { data, error } = await api.getUserWorkoutLogListByPlanAndDate(
    { userId, planUuid, date: logDate }, // pathParams
    { page: 1, per_page: 10 } // queryParams (optional)
  );

  if (error) {
    console.error('Error fetching workout logs:', error);
    return;
  }
  if (data && data.result) {
    console.log('Workout logs:', data.result);
  }

  // For the path without /date (but operation still expects date in pathParams, so pass null)
   const { data: data2, error: error2 } = await api.getUserWorkoutLogListByPlan(
    { userId, planUuid, date: null }, // pathParams
    { page: 1, per_page: 10 } // queryParams (optional)
  );
   if (error2) {
    console.error('Error fetching workout logs by plan:', error2);
    return;
  }
  if (data2 && data2.result) {
    console.log('Workout logs by plan:', data2.result);
  }
}
*/

// Note: The camelCase helper function is not strictly necessary if you prefer to name
// the api methods directly matching the operation IDs (e.g., api.get_WhitelistList).
// However, camelCasing (e.g., api.getWhitelistList) is a common JavaScript convention.
// I've used the operation IDs directly as function names (e.g. getWhitelistList from get_WhitelistList)
// after camelCasing for this generation. If an operationId was `getFoo`, it would be `api.getFoo`.
// The current operation IDs like `get_WhitelistList` become `api.getWhitelistList`.
// For the conflicting `get_UserWorkoutLogList`, I've used more descriptive names.

// A small helper to make function names more conventional if desired,
// but the current approach uses the operationId (camelCased) as the base.
// For example, `get_WhitelistList` becomes `getWhitelistList`.
// If you want to keep underscores, you can adjust the naming.
// The provided solution already converts `get_WhitelistList` to `getWhitelistList` etc.
// by manually deriving the name. The `camelCase` helper was illustrative
// but not used in the final generation logic for this response.
// The function names are derived by taking the operationId string (e.g., 'get_WhitelistList'),
// and converting it to camelCase (e.g., 'getWhitelistList').

// The provided code uses manually derived camelCase names based on operation IDs.
// For example, `get_WhitelistList` becomes `getWhitelistList`.
// `post_UserDtlsUpsert` becomes `postUserDtlsUpsert`.
// This is a common and clean approach.
